import { PropsWithChildren, ReactElement } from "react";
import styles from "./ContentBlock.module.less";
import classNames from "classnames";

export type ContentBlockProps = {
	size: "small" | "large";
};

export const ContentBlock = (props: PropsWithChildren<ContentBlockProps>): ReactElement => {
	const {
		size,
		children
	} = props;

	return (
		<div className={styles.root}>
			<div
				className={classNames(
					styles.block,
					{
						[styles.block_small]: size === "small",
						[styles.block_large]: size === "large"
					}
				)}
			>
				{children}
			</div>
		</div>
	);
};
ContentBlock.displayName = "ContentBlock";
